<template>
  <div>
    <!-- Si hay más de una unidad -->
    <template v-if="amount > 1">
      <!-- Con descuento -->
      <div v-if="hasDiscount" class="d-flex justify-content-between align-items-center mb-2">
        <div>
          <p class="text-decoration-line-through red-strike mb-2">
            <span class="fw-semibold">Precio:</span> {{ unitPrice }}
          </p>
          <p class="m-0"><span class="fw-semibold">Precio:</span> {{ discountUnitPrice }}</p>
        </div>
        <div>
          <p class="text-decoration-line-through red-strike mb-2">
            <span class="fw-semibold">Total:</span> {{ totalPrice }}
          </p>
          <p class="m-0"><span class="fw-semibold">Total:</span> {{ discountTotalPrice }}</p>
        </div>
      </div>

      <!-- Sin descuento -->
      <div v-else class="d-flex justify-content-between align-items-center mb-4">
        <div><span class="fw-semibold">Precio:</span> {{ unitPrice }}</div>
        <div><span class="fw-semibold">Total:</span> {{ totalPrice }}</div>
      </div>
    </template>

    <!-- Si hay solo una unidad -->
    <template v-else>
      <!-- Con descuento -->
      <div v-if="hasDiscount" class="col-md-12 text-end">
        <p class="text-decoration-line-through red-strike">{{ unitPrice }}</p>
        <p>{{ discountUnitPrice }}</p>
      </div>

      <!-- Sin descuento -->
      <div v-else class="col-md-12 text-end">
        <p><span class="fw-semibold">Precio:</span> {{ unitPrice }}</p>
      </div>
    </template>
  </div>
</template>

<script setup>
import { usePriceKey } from '@/composables/usePriceKey'
import { computed, getCurrentInstance } from 'vue'

const { priceKey, priceDiscountKey } = usePriceKey()
const props = defineProps({ product: Object, amount: Number })

const globalProperties = getCurrentInstance().appContext.config.globalProperties
const format = globalProperties.$formatcurrency

// 🔸 NUEVO: basePrice y baseDiscountPrice centralizados
const basePrice = computed(() => props.product?.[priceKey.value] || props.product?.price)
const baseDiscountPrice = computed(
  () => props.product?.[priceDiscountKey.value] || props.product?.price_discount
)

const unitPrice = computed(() => format(basePrice.value))
const discountUnitPrice = computed(() => format(baseDiscountPrice.value))
const totalPrice = computed(() => format(basePrice.value * props.amount))
const discountTotalPrice = computed(() => format(baseDiscountPrice.value * props.amount))

const hasDiscount = computed(() => baseDiscountPrice.value < basePrice.value)
</script>
